
import { mapState, mapGetters } from "vuex";
import RefreshButton from "../common/refresh-button.vue";
import SettingsButton from "../common/settings-button.vue";
import appVolumeHandler from "../common/app-volume-handler.vue";
import SubscriptionBanner from "../common/subscription-banner.vue";
import IntegrateBrandsToChannelsMobileDialog from "../dialogs/integrate-brands-to-channels-mobile-dialog.vue";
import AddNewBrandDialog from "../dialogs/add-new-brand-dialog.vue";
import BrandHamburgerMenu from "./brand-hamburger-menu.vue";
import LocationOnlineStatusHandler from "../reciever/location-online-status-handler.vue";
import StoreOnlineOfflineBanner from "./store-online-offline-banner.vue";
export default {
  components: {
    RefreshButton,
    SettingsButton,
    appVolumeHandler,
    SubscriptionBanner,
    IntegrateBrandsToChannelsMobileDialog,
    AddNewBrandDialog,
    BrandHamburgerMenu,
    LocationOnlineStatusHandler,
    StoreOnlineOfflineBanner
  },
  data() {
    return {
      showBrandsChannelIntegrationDialog: false,
      showAddBrandDialog: false,
      showStoreOnlineOfflineBanner: false,
      isOnline: null
    };
  },
  computed: {
    ...mapState("restaurant", ["locationDetails"]),
    ...mapGetters("restaurant", ["hasMultipleBrands"])
  },
  methods: {
    showBrandsDialog() {
      this.showBrandsChannelIntegrationDialog = true;
    },
    showStoreStatusBanner(val) {
      this.isOnline = val;
      this.showStoreOnlineOfflineBanner = true;
    }
  }
};
